export function removeDuplicated() {
    const array = this || [];
    return Array.from(new Set(array));
}
//# sourceMappingURL=removeDuplicated.js.map